<template>

  <div :class="{selected : selected}" class="share" v-on:click="updateSelected()">
    <div class="icon" >
      <i class="far fa-square" v-if="!selected"></i>
      <i class="fas fa-check-square" v-if="selected"></i>
    </div>
    <span><strong>{{share.sender_email}}</strong> has shared their study notes '<strong>{{share.chapter_name}}</strong>' with you.</span>
    <div class="clearfix"></div>
  </div>
            
</template>
<script>
  import _ from 'underscore'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    props: {
      share: Object,
    },

    components: {
    },

    created() {
    },

    methods: {
      updateSelected() {
        if (!this.selected) {
          this.$store.dispatch('addShareToSelected', { share: this.share })
        } else {
          this.$store.dispatch('removeShareFromSelected', { share: this.share })
        }
      }
    },

    data() {
      return {

      }
    },

    computed: {
      ...mapGetters({
        selectedShareImportIds: 'selectedShareImportIds',
      }),
      selected() {
        return _.contains(this.selectedShareImportIds, this.share.id);
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .share { color: #AAAAAA; cursor: pointer; border-bottom: 1px solid #EEEEEE; padding: 20px 0px; }
  .share:hover { color: #666666; }
  .share.selected { color: #4285f4; }
  .share .icon { float: left; font-size: 20px; }
  .share span { float: left; padding-top: 2px; margin-left: 12px; }
</style>



// WEBPACK FOOTER //
// ReceiveChapterRow.vue?49688941